import React from "react";
import "./Global_Presence.css";

const Global_Presence = () => {
  return (
    <section className="Global_Presence">
      <div className="container">
        <p className="title_text">Global Presence</p>
        <p className="descn">
          Majesty’s commitment to sleep science knows no boundaries. Our global
          presence ensures that our innovative mattresses and accessories are
          accessible to international markets, maintaining the same high
          standards of quality and durability across every region. Join a global
          community that wakes up refreshed every single day.
        </p>
      </div>
    </section>
  );
};

export default Global_Presence;
